import moment from 'moment';

export default Backbone.Model.extend({

	// attributs préservés lors d'un merge collection (pas updated_at : toujours serveur)
	safe: [],

	isNew: function()
	{
		return !this.has( 'id' ) /*&& this.has('uuid')*/;
	},

	// Et prêt pour être sauvegardé sur le serveur
	isSavable: function()
	{
		return _.contains( [ 'create', 'update', 'delete' ], this.get('todo') );
	},

	// Pour les alertes ou les images
	isVisible: function()
	{
		return this.get('todo') != 'delete';// && ( !this.isNew() || this.has('todo') );
	},


	getId: function()
	{
		return this.has( this.idAttribute || 'id' ) ? this.get( this.idAttribute || 'id' ) : this.cid;
	},

	getDate: function( key, format )
	{
		return moment( this.get(key) ).format( format || 'DD/MM/YYYY [à] HH[h]mm' ).replace(' à 00h00', '');
	},

	toFixed: function( key, dec )
	{
		if( !this.has( key ) )
		{
			return '…';
		}
		var val = this.get( key );
		return isNaN( val ) ? '???' : val.toFixed( dec );
	},

	getTruncated: function( key, length, ellips )
	{
		var string = this.get( key );
		if( !_.isString( string ) )
		{
			return string;
		}

		string = string.replace( /\s+/g, ' ');
		if( _.size( string ) <= length )
		{
			return string;
		}

		return string.substr( 0, length ) + ( ellips || '…' );
	},

	toUrl: function( url )
	{
		return url+'/'+this.getId();
	},


// 	hasChanged: function()
// 	{
// 		return this.has('todo');
// 	},

	setErrors: function( errors )
	{
		this.validationError = errors;
		this.trigger('change'); // Il y a eu un changement !
	},
	getErrors: function()
	{
		return this.validationError;
// 		return _.extend( {}, this.serverError, this.validationError );
	},
	addErrors: function( errors )
	{
		this.setErrors( _.extend( this.validationError || {}, errors ) );
	},
	hasError: function( key )
	{
		var errors = this.getErrors();
		return key ? _.has( errors, key ) : !!_.size( errors );
	},
	getError: function( key )
	{
		var errors = this.getErrors();
		return _.has( errors, key ) ? errors[key] : null;
	},


	getLastModified: function()
	{
		return this.get('updated_at');
	},

	// Date de référence pour If-Modified-Since (objets synchronisés uniquement)
	getIfModifiedSince: function()
	{
		if( this.isNew() || this.has('todo') )
		{
			return;
		}

		return this.get('updated_at');
	},


	update: function( data, options )
	{
		data = ( _.has( options, 'parse' ) && options.parse ) ? this.parse( data ) : data;

		if( !this.has('updated_at') || !_.has( data, 'updated_at' ) || !this.has('todo') || !data['updated_at'] <= this.get('updated_at') )
		{
			// Supprimer toutes les valeurs actuelles qui ne sont pas données et pas "safe"
			this.set( this.pick( _.difference( this.keys(), _.keys( data ), this.safe ) ), _.extend( { unset: true }, options ) );

			// Mettre à jour avec les données (sauf "safe")
			this.set( _.omit( data, this.safe ), options );
		}

		// updated_at = toujours la valeur serveur
		if( _.has( data, 'updated_at' ) )
		{
			this.set( 'updated_at', data.updated_at, options );
		}

		// etag = toujours la valeur serveur
		if( _.has( data, 'etag' ) )
		{
			this.set( 'etag', data.etag, options );
		}

		this.trigger( 'update', this, options );
	},


	sync: function( method, model, options )
	{
		options = options || {};

		if( method === 'delete' && !this.isNew() )
		{
			options.data = _.extend( {}, options.data, {
				uuid: this.get('uuid'),
				updated_at: this.get('updated_at'),
				etag: this.has('etag') ? this.get('etag') : null
			});
		}

		var xhr = Backbone.sync( method, model, options );

		xhr.done( function( json, status, jqXHR )
		{
			if( jqXHR && ( jqXHR.status === 204 || jqXHR.status === 304 || status === 'notmodified' ) )
			{
				console.log( method, model, 'not modified' );
				model.trigger( 'sync', model, xhr, options );
				model.trigger( method );
				return;
			}

			if( status == 'success' && json && !_.isEmpty( json ) )
			{
				model.update( json, _.extend( { validate: false, parse: true }, options ) );

				if( model.collection )
				{
					model.collection.trigger( 'update', model.collection );
				}

				// Miroir Dexie après réponse API
				if( app.persistModel )
				{
					app.persistModel( model );
				}
			}

			console.log( method, model );
			model.trigger( 'sync', model, xhr, options);
			model.trigger( method );
		});

		xhr.fail( function( xhr, status, name )
		{
			// 400 = erreur de validation sur le serveur
			if( xhr.status == 400 )
			{
				model.setErrors( model.parse( xhr.responseJSON ) );
				model.trigger( 'error', model.getErrors() );
			}

			// 401 = utilisateur n'est pas connecté
			else if( xhr.status == 401 )
			{
				app.signout();
			}

			// 403 = action interdite (droits insuffisants)
			else if( xhr.status == 403 )
			{
				console.warn( status, name, xhr.responseJSON );

				model.unset( 'todo' );

				var message = ( xhr.responseJSON && xhr.responseJSON.error )
					? xhr.responseJSON.error
					: 'Vous n\'êtes pas autorisé à effectuer cette action. Vos modifications locales ont été annulées.';

				model.setErrors( { error: message } );
				model.trigger( 'error', model.getErrors() );
				app.addMessage( message, 'warning' );

				if( method == 'create' && model.collection )
				{
					model.collection.remove( model, options );
				}
				else if( !model.isNew() )
				{
					model.fetch( { background: true, force: true } );
				}
			}

			// 404 = inexistant sur le serveur, donc on supprime ici !
			else if( xhr.status == 404 && model.collection )
			{
				console.warn( status, name, xhr.responseJSON );
				model.collection.remove( model, options );
			}

			// 409 = doublon UUID (création) ou conflit de version (update/delete)
			else if( xhr.status == 409 )
			{
				console.warn( status, name, xhr.responseJSON );

				if( model.isNew() || model.get('todo') == 'create' )
				{
					model.unset('todo');
					model.fetch({ force: true });
				}
				else
				{
					var message = 'Cet élément a été modifié sur le serveur entre-temps. Vos modifications locales n\'ont pas été enregistrées.';
					model.setErrors({ error: message });
					model.trigger( 'error', model.getErrors() );
					app.addMessage( message, 'warning' );
					model.fetch({ background: true, force: true });
				}
			}

			// Autre erreur inconnue
			else
			{
				console.error( status, name, xhr.responseJSON );
				model.setErrors( xhr.responseJSON );
			}
		});

		return xhr;
	},


	fetch: function( options )
	{
		options = app.getStore('settings').addIfModifiedSinceHeader( this, options || {} );

		return this.sync( 'read', this, _.extend( { validate: false, parse: true }, options ) );
	},

	save: function( data, options )
	{
		if( data ) this.set( data );

		return this.isValid()
			? this.sync( this.isNew() ? 'create' : 'update', this, options || {} )
			: $.Deferred().reject( this.getErrors() )
		;
	},

	destroy: function( options )
	{
		return this.sync( 'delete', this, options || {} );
	},


	commit: function()
	{
		var deferred = $.Deferred();

		try
		{
			_.result( this, 'url' );
		}
		catch( e )
		{
			deferred.resolve();
			return deferred.promise();
		}

		var user = app.getStore( 'user' );
		if( this === user && !app.getStore( 'settings' ).hasToken() )
		{
			deferred.resolve();
			return deferred.promise();
		}

		if( this.isSavable() )
		{
			var op = ( this.get( 'todo' ) == 'delete' ) ? this.destroy() : this.save();

			if( !op )
			{
				deferred.resolve();
				return deferred.promise();
			}

			op.done( _.bind( function()
			{
				this.unset( 'todo' );
			}, this ) );

			op.always( function()
			{
				deferred.resolve();
			} );

			return deferred.promise();
		}

		var fetchOptions = {};
		if( this === user && app.is( 'authenticated' ) )
		{
			fetchOptions.force = true;
		}

		this.fetch( fetchOptions ).always( function()
		{
			deferred.resolve();
		} );

		return deferred.promise();
	},


	persist: function()
	{
		if( this.collection && _.isFunction( this.collection.persist ) )
		{
			return this.collection.persist();
		}

		return app.storage.write( 'data', this.file, JSON.stringify( this.toJSON() ) );
	},

	restore: function()
	{
		if( this.collection && _.isFunction( this.collection.restore ) )
		{
			return this.collection.restore();
		}

		return app.storage.read( 'data', this.file ).done( _.bind( function( text )
		{
			try
			{
				this.set( this.parse( JSON.parse( text ) ), { validate: false, parse: true } );
// 				this.isValid();
			}
			catch( error )
			{
				console.warn( 'Model.restore', this, error );
			}
		},this));
	},


	// Formulaires simplifiés ???
	getFieldLabel: function( key, label, attrs )
	{
		attrs = _.extend( { for: this.cid+'_'+key }, attrs );

		return $('<label/>', attrs ).html( label ).get(0).outerHTML;
	},
	getFieldInput: function( key, attrs )
	{
		attrs = _.extend( { id: this.cid+'_'+key, type: 'text', name: key, value: this.get(key), class: 'form-control' }, attrs );
		if( !_.contains( attrs.class.split(' '), 'form-control' ) ) { attrs.class+=' form-control'; }

		var invalid = _.has( this.validationError, key );
		if( invalid ) { attrs.class+= ' is-invalid'; }

		if( attrs.type == 'select' )
		{
			var choices = attrs.choices;
			var selected = _.isArray( attrs.value ) ? attrs.value : [ attrs.value ];

			delete attrs.choices;
			delete attrs.value;
			delete attrs.type;

			if( attrs.multiple )
			{
				attrs.multiple = 'multiple';
				attrs.name+= '[]';
			}
			else
			{
				delete attrs.multiple;
			}

			var select = $('<select/>',attrs);

			_.each( choices, function( label, value )
			{
				if( _.isObject( label ) || _.isArray( label ) )
				{
					var group = $('<optgroup/>',{ label: value }).appendTo( select );
					_.each( label, function( l, v )
					{
						$('<option/>', { value: v, selected: _.some( selected, function( s ) { return s==v; } ) } ).text( l ).appendTo( group )
					});
				}
				else
				{
					$('<option/>', { value: value, selected: _.some( selected, function( s ) { return s==value; } ) } ).text( label ).appendTo( select );
				}
			});


			return select.get(0).outerHTML;
		}

		if( attrs.type == 'radio' || attrs.type == 'checkbox' )
		{
			var choices = attrs.choices;
			var selected = _.isArray( attrs.value ) ? attrs.value : [ attrs.value ];

			delete attrs.choices;
			delete attrs.value;
// 			delete attrs.type;

			if( attrs.type == 'checkbox' )
			{
				attrs.name+= '[]';
			}

			var list = _.map( choices, function( label, value )
			{
				var i = {
					id: _.uniqueId( attrs.id + '_' ),
					type: attrs.type,
					name: attrs.name,
					value: value,
					class: invalid ? 'custom-control-input is-invalid' : 'custom-control-input',
					checked: _.some( selected, function( s ) { return s==value; } )
				};

				var l = {
					for: i.id,
					class: 'custom-control-label'
				};

				return $('<div/>', { class: 'custom-control custom-'+attrs.type })
					.append( $('<input/>',i) )
					.append( $('<label/>',l).text(label) )
					.get(0).outerHTML
				;
			});

			return list.join("\n");
		}

		if( attrs.type == 'boolean' )
		{
			var i = _.extend({},attrs,{
				type: 'checkbox',
				value: "1",
				class: invalid ? 'custom-control-input is-invalid' : 'custom-control-input',
				checked: !!attrs.value
			});

			return $( '<input/>', i ).get( 0 ).outerHTML;
		}

		if( attrs.type == 'textarea' )
		{
			var value = attrs.value;
			delete attrs.value;
			return $('<textarea>',attrs).html(value).get(0).outerHTML;
		}

		if( attrs.type == 'date' && attrs.value )
		{
			attrs.value = ( new Date( attrs.value  ) ).toISOString().substr(0,10);
		}

// 		if( attrs.type == 'password' ) { attrs.value = ''; }

		return $('<input/>', attrs ).get(0).outerHTML;
	},

	getFieldError: function( key, attrs )
	{
		attrs = _.extend( { class: 'invalid-feedback d-block' }, attrs );
// 		if( _.has( this.validationError, key ) )
		if( this.hasError( key ) )
		{
// 			return $( '<div/>', attrs ).text( this.validationError[key] ).get(0).outerHTML;
			return $( '<div/>', attrs ).text( this.getError(key) ).get(0).outerHTML;
		}

		return '';
	},

	getFormField: function( key, label, input_attrs, label_attrs, error_attrs )
	{
		if( input_attrs.type == 'boolean' )
		{
			label_attrs = _.defaults( label_attrs, { class: "" } );
			label_attrs.class += " custom-control-label";

			return '<div class="custom-control custom-checkbox">'
				+ this.getFieldInput( key, input_attrs ) + this.getFieldLabel( key, label, label_attrs ) + this.getFieldError( key, error_attrs )
			+ '</div>';
		}

		return this.getFieldLabel( key, label, label_attrs ) + this.getFieldInput( key, input_attrs ) + this.getFieldError( key, error_attrs );
	},

	getFormError: function()
	{
		var errors = _.filter( this.validationError, function( error, key ) { return key == 'error' || typeof key == 'number' } );
		if( _.size( errors ) <= 0 )
		{
			return '';
		}

		var ul = $( "<ul/>", { class: 'list-unstyled alert alert-danger' } );
		_.each( errors, function( error ) { ul.append( $('<li/>').text( error ) ) } );
		return ul.get(0).outerHTML;
	},
});
